import { ArrowLeft, ArrowRight, Settings } from 'lucide-react';
import { useAuth } from './AuthContext';
import { Button } from './components/ui/button';
import { WmsAlertsBell } from './WmsAlertsBell';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_scriptbuilder/artifacts/6hlprpgp_Green_Logo.png";
const ALERT_ROLES = ['agent', 'estate_agent', 'branch_manager', 'branch_admin'];

export function AppHeader({ onBack, backLabel, arrowRight = false }) {
  const { user, logout } = useAuth();
  const isSuperAdmin = user?.role === 'super_admin';
  const showBell = ALERT_ROLES.includes(user?.role);
  let backTarget = 'tools';
  try { backTarget = sessionStorage.getItem('ns_back_target') || 'tools'; } catch {}
  const editorToHub = user?.role === 'editor' && (!user?.editor_admin || backTarget === 'hub');
  const label = backLabel || (editorToHub ? 'Back to Dashboard' : 'Back to Tools');

  return (
    <header className="header-bar" data-testid="app-header">
      <div className="header-left">
        <img src={LOGO_URL} alt="Nichecom" className="logo-small" />
      </div>
      <div className="header-right">
        {onBack && (
          <button onClick={onBack} className="back-to-menu" data-testid="back-to-tools-btn">
            {!arrowRight && <ArrowLeft className="back-icon" />}
            {label}
            {arrowRight && <ArrowRight className="back-icon" />}
          </button>
        )}
        {showBell && <WmsAlertsBell />}
        {isSuperAdmin && (
          <button type="button" className="header-cog" onClick={() => window.dispatchEvent(new CustomEvent('nichesocial:open-module', { detail: 'admin' }))} title="Admin Panel" aria-label="Admin Panel" data-testid="header-admin-cog">
            <Settings size={18} />
          </button>
        )}
        <div className="user-avatar" title={user?.name || 'User'}>
          {(user?.name || 'U').split(' ').map(n => n[0]).join('').slice(0, 2)}
        </div>
        <Button variant="ghost" size="sm" onClick={logout} className="logout-btn">
          Sign Out
        </Button>
      </div>
    </header>
  );
}
